import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-css-loader',
  templateUrl: './css-loader.component.html',
  styleUrls: ['./css-loader.component.css']
})
export class CssLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
